import { render, staticRenderFns } from "./CourseSectionViewStudentsList.vue?vue&type=template&id=19341cc0&scoped=true&"
import script from "./CourseSectionViewStudentsList.vue?vue&type=script&lang=js&"
export * from "./CourseSectionViewStudentsList.vue?vue&type=script&lang=js&"
import style0 from "./CourseSectionViewStudentsList.vue?vue&type=style&index=0&id=19341cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19341cc0",
  null
  
)

export default component.exports